(function(module) {
try {
  module = angular.module('betosyswebapp');
} catch (e) {
  module = angular.module('betosyswebapp', []);
}
module.run(['$templateCache', function($templateCache) {
  $templateCache.put('components/dashboard/vehicleDetails/vehicleDetailWidget.tpl.html',
    '<div class=""><loading-animation ng-if="!isWidgetPreInitFinished"></loading-animation><no-authorize ng-if="isNotAuthorized=== true"></no-authorize><no-data-available ng-if="isNotAuthorized=== false && isDataNotAvailable === true"></no-data-available></div><div class="row"><div class="col-md-12 col-sm-12 col-xs-12" style=""><div ng-if="isDataNotAvailable === false && dataLoadingFinished === true"><span ng-repeat="item in buttonsArray"><button type="button" class="btn btn-primary btn-filter {{item._isActive}}" id="{{item._buttonName}}Button" style="margin: 5px" data-toggle="button" aria-pressed="false" autocomplete="off" ng-click="updateFilter(item._buttonID)"><span ng-bind="item._buttonName"></span></button></span><jqx-grid id="{{overviewGridPrefix}}vehicleDetailsWidgetList" jqx-settings="vehicleDetialsWidgGridSettings" jqx-create="dataLoadingFinished"></jqx-grid></div></div></div>');
}]);
})();



// WEBPACK FOOTER //
// ./.tmp/components/dashboard/vehicleDetails/vehicleDetailWidget.tpl.js